import { render, staticRenderFns } from "./generalCell.vue?vue&type=template&id=ec79b812&scoped=true"
import script from "./generalCell.vue?vue&type=script&lang=js"
export * from "./generalCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec79b812",
  null
  
)

export default component.exports